import React from 'react';
import { Checkbox, FormControlLabel, SxProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface Props {
  label: string;
  name: string;
  isRequired?: boolean;
  defaultValue?: boolean;
  isDisabled?: boolean;
  labelSx?: SxProps;
  onChangeFn?(event: React.ChangeEvent<HTMLInputElement>): void;
}

export function AppControlledCheckbox({
  label,
  name,
  isRequired = false,
  defaultValue = false,
  isDisabled,
  labelSx,
  onChangeFn = () => {},
}: Props): JSX.Element {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      rules={{ required: isRequired }}
      render={({ field: { onChange, value } }) => {
        return (
          <FormControlLabel
            control={
              <Checkbox
                onChange={(event) => {
                  onChange(event.target.checked);
                  onChangeFn(event);
                }}
                checked={value}
                disabled={isDisabled}
              />
            }
            label={label}
            sx={labelSx}
          />
        );
      }}
    />
  );
}
